(function($){
  $(document).ready(function(){

    $(document).on('mousedown', '.ws_card_wrapper a, .product-teaser__link', function(e){
      e.preventDefault();
      const $l = $(this);
      let href = $l.attr('href');
      href = href + '?pop=1'

      pu.open_ajax(href, 'ajax');

      return false;
    });

  });
})(jQuery);
